import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Button from '../Button'
import { AlertTriangle } from '@entrata/portals-common/lib/icons'
import {
  StyledLoaderDiv,
  StyledContentDiv,
  StyledH3,
  StyledLoaderP,
} from './atoms'
import { connect } from 'react-redux'

const PageLoaderError = props => {
  useEffect(() => {
    const { offline, retry } = props
    if (typeof retry === 'function' && offline === false) {
      retry()
    }
  }, [props.offline])

  const { content, offline, retry, title } = props

  return (
    <StyledLoaderDiv>
      <StyledContentDiv>
        <AlertTriangle size={48} />
        <StyledH3>{title}</StyledH3>
        <StyledLoaderP>{content}</StyledLoaderP>
        {offline && (
          <StyledLoaderP>
            {__(
              'The page will try to reload when your connection is reestablished.',
            )}
          </StyledLoaderP>
        )}
        {typeof retry === 'function' && !offline && (
          <Button appearance='action' onClick={retry}>
            {__('Reload Page')}
          </Button>
        )}
      </StyledContentDiv>
    </StyledLoaderDiv>
  )
}

PageLoaderError.propTypes = {
  content: PropTypes.node,
  offline: PropTypes.bool,
  retry: PropTypes.func.isRequired,
  title: PropTypes.node,
}

PageLoaderError.defaultProps = {
  content: __(
    'An error occurred while loading this page. We have logged the error with our development team.',
  ),
  title: __('An error has occurred'),
}

export default connect(({ offline }) => ({ offline }))(PageLoaderError)
